<script setup lang="ts">
import PartyImage from "@/assets/images/party.png";
import { useModalManager } from "@/composables/useModalManager";
import { ModalEnum } from "@/types/enums";
import { ref, watch } from "vue";
import BaseModal from "./BaseModal.vue";

const { activeModal } = useModalManager();
const show = ref(false);

watch(
  () => activeModal.value,
  (modal) => {
    show.value = modal === ModalEnum.PaymentSuccessModal;
  },
  { immediate: true },
);

const onClose = () => {
  show.value = false;
  activeModal.value = null;
};
</script>

<template>
  <BaseModal @close="onClose" width="780px" :hideHead="true" v-model:visible="show">
    <div class="flex flex-col items-center justify-center p-1 pb-4 text-center md:p-4">
      <img :src="PartyImage" alt="Success" class="mx-auto mb-4 h-32 w-32" />
      <h2 class="text-[2rem] font-bold text-black">Thank you!</h2>
      <div class="mt-2 flex flex-col gap-2 text-[1.025rem] font-medium text-black md:gap-0">
        <span>Your payment was processed successfully and your subscription is now active.</span>
        <span>Thank you for choosing 4C Predictions.</span>
      </div>
      <Button class="mt-4 min-w-[200px] px-4 py-2" @click="onClose">
        <span class="font-semibold">View Predictions</span>
      </Button>
    </div>
  </BaseModal>
</template>
